import React from 'react';
import { Sparkles } from 'lucide-react';

const WelcomeBanner = ({ userName }) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Buenos días';
    if (hour < 18) return 'Buenas tardes';
    return 'Buenas noches';
  };

  const firstName = userName?.split(' ')[0] || 'Usuario';

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary to-primary-dark p-6 lg:p-8 text-white mb-8">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 400 200" fill="none">
          <circle cx="350" cy="100" r="150" fill="white" />
          <circle cx="50" cy="150" r="80" fill="white" />
          <circle cx="200" cy="30" r="60" fill="white" />
        </svg>
      </div>

      <div className="relative z-10">
        <div className="flex items-center gap-2 mb-2">
          <Sparkles size={20} className="text-white/80" />
          <span className="text-white/80 text-sm font-medium">Sonneil Intranet</span>
        </div>
        <h1 className="text-2xl lg:text-3xl font-bold mb-2">
          {getGreeting()}, {firstName} 👋
        </h1>
        <p className="text-white/80 max-w-xl">
          Bienvenido al portal corporativo de Sonneil. Accede a todas las herramientas, 
          recursos y documentación que necesitas para tu día a día.
        </p>
      </div>
    </div>
  );
};

export default WelcomeBanner;


